<script setup>
import { onMounted, ref } from 'vue'
import { getCookie, setCookie } from '../utils/cookies.js'

const showConsent = ref(false)

onMounted(() => {
  if (!getCookie('cookie-consent')) {
    setTimeout(() => {
      showConsent.value = true
    }, 1000)
  }
})

function acknowledgeCookies() {
  setCookie('cookie-consent', 'accepted', 365)
  showConsent.value = false
}
</script>

<template><div v-if="showConsent" class="bottom-right-cookie-container">
    <v-card class="update-card" :elevation="10">
      <div class="update-header">
        <div class="update-icon">
          <v-icon icon="mdi-cookie" color="white" size="large" />
        </div>
        <div class="update-title-section">
          <div class="update-title">Cookie notice</div>
          <div class="update-version">Essential cookies</div>
        </div>
      </div>
      <div class="update-content">
        <p>This site uses essential cookies for proper functioning and improved performance.</p>
        <div class="update-features">
          <div class="feature-item">
            <v-icon size="x-small" class="feature-icon">mdi-check-circle</v-icon>
            <span>Performance improvements</span>
          </div>
          <div class="feature-item">
            <v-icon size="x-small" class="feature-icon">mdi-check-circle</v-icon>
            <span>Essential functionality</span>
          </div>
        </div>
      </div>
      <div class="update-actions">
        <v-btn class="accept-btn" @click="acknowledgeCookies">
          <v-icon icon="mdi-check-circle-outline" size="small" class="mr-1" />
          I Understand
        </v-btn>
      </div>
    </v-card>
  </div></template>

<style scoped>
.bottom-right-cookie-container {
  position:fixed;
  bottom:20px;
  right:20px;
  z-index:9999;
  width:320px;
  animation:fadeIn .4s ease-out}
.update-card {
  border-radius:12px!important;
  width:100%;
  overflow:hidden;
  background-color:var(--glass)!important;
  border:1px solid var(--line)!important;
  box-shadow:0 20px 50px #0000008c!important}
.update-header {
  display:flex;
  align-items:center;
  padding:16px}
.update-icon {
  background:#ffffff1a;
  border-radius:10px;
  width:40px;
  height:40px;
  display:flex;
  align-items:center;
  justify-content:center;
  margin-right:12px}
.update-title-section {
  display:flex;
  flex-direction:column}
.update-title {
  font-weight:700;
  letter-spacing:.02em;
  color:var(--ink);
  font-size:.95rem;
  text-transform:uppercase}
.update-version {
  font-size:.72rem;
  padding:2px 8px;
  background-color:var(--glass);
  border-radius:999px;
  color:var(--mute);
  display:inline-block;
  margin-top:4px;
  width:fit-content}
.update-content {
  padding:0 16px 12px;
  color:var(--ink-soft);
  font-size:.86rem}
.update-features {
  background-color:var(--glass);
  border-radius:10px;
  border:1px solid var(--line);
  margin-top:12px;
  padding:12px}
.feature-item {
  display:flex;
  align-items:center;
  margin-bottom:8px;
  color:var(--ink-soft);
  font-size:.8rem}
.feature-item:last-child {
  margin-bottom:0}
.feature-icon {
  margin-right:8px;
  color:var(--status-success)!important}
.update-actions {
  display:flex;
  justify-content:flex-end;
  align-items:center;
  padding:12px 16px;
  background-color:var(--glass);
  border-top:1px solid var(--line)}
.accept-btn {
  background:var(--hover-color)!important;
  color:var(--ink)!important;
  font-weight:700;
  letter-spacing:.02em;
  font-size:.8rem!important;
  padding:0 14px!important;
  border-radius:10px!important;
  text-transform:none!important}
.accept-btn:hover {
  background:var(--active-color)!important}
@keyframes fadeIn {
  0% {
  opacity:0;
  transform:translateY(30px)}
to {
  opacity:1;
  transform:translateY(0)}
}p {
  font-size:.85rem;
  line-height:1.5;
  margin:0;
  color:var(--ink)}
span {
  font-size:.8rem;
  color:var(--ink)}
</style>
